import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import { ReactComponent as Star } from '../../assets/star.svg';
import LoadingSpinner from '../LoadingSpinner';

import styles from './PersonalContent.module.scss';

export interface PersonalContentProps {
  chart: React.ReactNode;
  contentPanel: React.ReactNode;
  loading?: boolean;
}

export function PersonalContent({ chart, contentPanel, loading }: PersonalContentProps) {
  return (
    <div className={styles.content}>
      <div className={styles.wrapper}>
        <div className={styles.chart}>{chart}</div>
        <div className={styles.divider}>
          <div className={styles.dividerLine}></div>
          <Star className={styles.dividerIcon} />
          <div className={styles.dividerLine}></div>
        </div>
        <div className={styles.description}>{contentPanel}</div>
      </div>
      {/* @ts-expect-error framer-motion types incompatible with @types/react 18 */}
      <AnimatePresence>
        {loading && (
          <motion.div
            className={styles.loaderOverlay}
            initial={{ opacity: 0, backdropFilter: 'blur(0px)' }}
            animate={{ opacity: 1, backdropFilter: 'blur(3px)' }}
            exit={{ opacity: 0, backdropFilter: 'blur(0px)' }}
            transition={{ duration: 0.3 }}
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              transition={{ duration: 0.3 }}
            >
              <LoadingSpinner />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
